export const resourceName = 'Permissão de usuário';
export const resourcePluralTitle = 'Permissões de usuários';
// @todo: review
export const resourceKey = 'permissao/filtro';
export const resourceKeyItem = 'permissao';

export const idKey = 'id';

export const headers = [
  { label: 'Menu', key: 'rotina.nomeMenu', isVisible: true },
  { label: 'Rotina', key: 'rotina.nome', isVisible: true },
  { label: 'Ativo', key: 'ativo', isVisible: true },
];
